import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '../../lib/utils';
import { useBrowserModePortalContainer } from '@/features/browser-mode';
import { useClearStuckBodyPointerEventsOnUnmount } from './useClearStuckBodyPointerEvents';
import { useModalScrimPresence } from '@/layout/store/modalScrimStore';

export const Sheet = DialogPrimitive.Root;
export const SheetClose = DialogPrimitive.Close;

const SheetOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => {
  useModalScrimPresence();
  return <DialogPrimitive.Overlay ref={ref} className={cn('app-region-no-drag fixed inset-0 z-(--z-overlay) bg-black/45 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0', className)} {...props} />;
});
SheetOverlay.displayName = 'SheetOverlay';

export const SheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => {
  const container = useBrowserModePortalContainer();
  useClearStuckBodyPointerEventsOnUnmount();
  return (
    <DialogPrimitive.Portal container={container}>
      <SheetOverlay />
      <DialogPrimitive.Content ref={ref} className={cn('fixed inset-x-0 bottom-0 z-(--z-overlay) max-h-[72vh] border-t border-border bg-surface-raised text-foreground dialog-elevation data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:slide-in-from-bottom data-[state=closed]:slide-out-to-bottom', className)} {...props}>
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
});
SheetContent.displayName = 'SheetContent';

export const SheetTitle = DialogPrimitive.Title;
export const SheetDescription = DialogPrimitive.Description;
